import { render, staticRenderFns } from "./OverlayFooterLocale.vue?vue&type=template&id=1f811b48&"
import script from "./OverlayFooterLocale.vue?vue&type=script&lang=js&"
export * from "./OverlayFooterLocale.vue?vue&type=script&lang=js&"
import style0 from "./OverlayFooterLocale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/overlay_footer_locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FFooter%2FOverlayFooterLocale.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports